export const PING_URL = '//www.pbs.org/otterhealthcheckpbs.html'
const PING_TIMEOUT_MS = 5000

export function verifyConnectivity(): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false

    const timeout = setTimeout(() => {
      if (!settled) {
        settled = true
        resolve(false)
      }
    }, PING_TIMEOUT_MS)

    fetch(PING_URL, { mode: 'no-cors' })
      .then(() => {
        if (!settled) {
          settled = true
          clearTimeout(timeout)
          resolve(true)
        }
      })
      .catch(() => {
        if (!settled) {
          settled = true
          clearTimeout(timeout)
          resolve(false)
        }
      })
  })
}
